import { render, staticRenderFns } from "./OrganizationCustomers.vue?vue&type=template&id=55587338"
import script from "./OrganizationCustomers.vue?vue&type=script&lang=js"
export * from "./OrganizationCustomers.vue?vue&type=script&lang=js"
import style0 from "./OrganizationCustomers.vue?vue&type=style&index=0&id=55587338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports